import ObjectificationReflection from "./reflection";

export default {
     __init__ : [
        'objectificationReflection'
    ],
    objectificationReflection: ['type', ObjectificationReflection]
};